import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from 'app/model/user';
import { UserData } from 'app/model/user-data';
import { FilterData } from 'app/model/user-data/filter-data';
import { RestfulApiService } from 'app/services/restful-api.service';
import { ModelPrepped } from 'app/type/model-prepped';
import { ModelWithoutId } from 'app/type/model-with-id';

class UserDataService extends RestfulApiService<UserData<unknown>, User> {
    public save<T>(entity: ModelWithoutId<UserData<T>>, parent?: User): Observable<UserData<T>> {
        return super.save(entity, parent) as Observable<UserData<T>>;
    }

    public getFilterData(user: User): Observable<UserData<FilterData[]> | undefined> {
        return this.listAll({ extraParams: { type: 0 } }, user).pipe(
            map((value) => {
                if (0 === value.length) {
                    return undefined;
                }

                if (1 !== value.length) {
                    // there should never be more than one value returned here thanks to foreign key
                    throw new Error('Expected 1 result but got more.');
                }

                return value[0] as UserData<FilterData[]>;
            }),
        );
    }

    protected getFormName(): string {
        return 'user_data';
    }

    protected getPath(parent: User | undefined): string {
        if (!parent) {
            throw new Error('Parent brand is required in AttributeService');
        }

        return `users/${parent.id}/data`;
    }

    protected prepareSaveData(entity: ModelWithoutId<UserData<unknown>>): ModelPrepped<UserData<unknown>> {
        const { ...rest } = entity;

        return rest;
    }
}

export const userDataService = new UserDataService();
